import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer from '../Common/Drawer/Drawer';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import InputText from '../Common/InputText';
import DatePicker from '../Common/DatePicker/DatePicker';
import { DATE_FORMAT } from '../../constants/constants';
import Moment from 'moment';
import Toggle from '../Common/Toggle/Toggle';

export default class ShowFiltersDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		let localParams = {
			projectIds: [],
			disciplineIds: [],
			departmentIds: [],
			phaseIds: [],
			communityIds: [],
			statusIds: [],
			tagIds: [],
			name: '',
			responsibleUserName: '',
			additionalInfo: '',
			targetDateStart: '',
			targetDateEnd: '',
			startDateStart: '',
			startDateEnd: '',
		};

		const mergedParams = { ...localParams, ...props.searchParams };

		this.state = {
			localParams: mergedParams,
		};
	}

	onFormChange = (name, value) => {
		this.setState({ localParams: { ...this.state.localParams, [name]: value } });
	};

	onDropdownChange = (value, name) => {
		const newValues = value.split(',').map(Number);
		this.onFormChange(name, newValues);
	};

	onDisciplineChange = (value) => {
		const newDisciplines = value ? value.split(',').map(Number) : [];

		// select all departments for all selected disciplines
		let deptIds = [];

		for (let i = 0; i < newDisciplines.length; i++) {
			const depts = this.props.columnFilters.departments.filter((m) => m.disciplineId === newDisciplines[i]);
			const ids = depts.map((m) => m.id);
			deptIds.push.apply(deptIds, ids);
		}

		this.setState({
			localParams: {
				...this.state.localParams,
				disciplineIds: newDisciplines,
				departmentIds: deptIds,
			},
		});
	};

	onDepartmentChange = (selectedIds) => {
		const newDepartmentIds = selectedIds ? selectedIds.split(',').map(Number) : [];
		const oldDepartmentIds = this.state.localParams.departmentIds.length > 0 ? this.state.localParams.departmentIds : [];
		const disciplineIds = this.state.localParams.disciplineIds.length > 0 ? this.state.localParams.disciplineIds : [];

		// if a new department was selected, make sure the discipline is selected
		if (newDepartmentIds.length > oldDepartmentIds.length) {
			const newDepartment = this.props.columnFilters.departments.find((m) => m.id === newDepartmentIds[newDepartmentIds.length - 1]);

			if (disciplineIds.indexOf(newDepartment.disciplineId) === -1) {
				disciplineIds.push(newDepartment.disciplineId);
			}
		}

		this.setState({
			localParams: {
				...this.state.localParams,
				disciplineIds: disciplineIds,
				departmentIds: newDepartmentIds,
			},
		});
	};

	onTextChange = (e) => {
		this.onFormChange(e.currentTarget.name, e.currentTarget.value);
	};

	onDateChange = (value, name) => {
		this.onFormChange(name, value);
	};

	onToggleChange = (name, value) => {
		if (value === false) value = null;
		this.setState({ localParams: { ...this.state.localParams, [name]: value } });
	};

	render() {
		const targetStart = this.state.localParams.targetDateStart ? Moment(this.state.localParams.targetDateStart).format(DATE_FORMAT) : '';
		const targetEnd = this.state.localParams.targetDateEnd ? Moment(this.state.localParams.targetDateEnd).format(DATE_FORMAT) : '';

		const startStart = this.state.localParams.startDateStart ? Moment(this.state.localParams.startDateStart).format(DATE_FORMAT) : '';
		const startEnd = this.state.localParams.startDateEnd ? Moment(this.state.localParams.startDateEnd).format(DATE_FORMAT) : '';

		return (
			<Drawer
				isOpen={true}
				isWide={true}
				title='Filters'
				onSaveClick={() => this.props.onComplete(this.state.localParams)}
				saveText='Update filters'
				onCancelClick={this.props.onCancel}>
				<div className='task-list-filters-drawer'>
					<Toggle name='isMilestone' text='Milestones Only' checked={this.state.localParams.isMilestone} onChange={this.onToggleChange} />
					{this.props.isStartDateActive && (
						<div className='mb-3'>
							<label>
								<strong>Start Date Range</strong>
							</label>
							<div className='row'>
								<div className='col-6 mt-2'>
									<DatePicker showIcon name='startDateStart' label='Start' onChange={this.onDateChange} value={startStart} />
								</div>
								<div className='col-6 mt-2'>
									<DatePicker showIcon name='startDateEnd' label='End' onChange={this.onDateChange} value={startEnd} />
								</div>
							</div>
						</div>
					)}
					<div className='mb-3'>
						<label>
							<strong>Target Date Range</strong>
						</label>
						<div className='row'>
							<div className='col-6 mt-2'>
								<DatePicker showIcon name='targetDateStart' label='Start' onChange={this.onDateChange} value={targetStart} />
							</div>
							<div className='col-6 mt-2'>
								<DatePicker showIcon name='targetDateEnd' label='End' onChange={this.onDateChange} value={targetEnd} />
							</div>
						</div>
					</div>
					<MultiSelectBox
						name='projectIds'
						label='Projects'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.projects}
						selectedValues={this.state.localParams.projectIds.toString()}
						isMulti={true}
						onChange={this.onDropdownChange}
					/>
					<MultiSelectBox
						name='disciplineIds'
						label='Disciplines'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.disciplines}
						selectedValues={this.state.localParams.disciplineIds.toString()}
						isMulti={true}
						onChange={this.onDisciplineChange}
					/>
					<MultiSelectBox
						name='departmentIds'
						label='Departments'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.departments}
						selectedValues={this.state.localParams.departmentIds.toString()}
						isMulti={true}
						onChange={this.onDepartmentChange}
					/>
					<MultiSelectBox
						name='tagIds'
						label='Tags'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.tags}
						selectedValues={this.state.localParams.tagIds.toString()}
						isMulti={true}
						onChange={this.onDropdownChange}
					/>
					<MultiSelectBox
						name='phaseIds'
						label='Phases'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.phases}
						selectedValues={this.state.localParams.phaseIds.toString()}
						isMulti={true}
						onChange={this.onDropdownChange}
					/>
					<MultiSelectBox
						name='communityIds'
						label='Communities'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.communities}
						selectedValues={this.state.localParams.communityIds.toString()}
						isMulti={true}
						onChange={this.onDropdownChange}
					/>
					<MultiSelectBox
						name='statusIds'
						label='Status'
						idField='id'
						valueField='name'
						options={this.props.columnFilters.statuses}
						selectedValues={this.state.localParams.statusIds.toString()}
						isMulti={true}
						onChange={this.onDropdownChange}
					/>
					<InputText
						name='name'
						label='Task Name'
						type='text'
						value={this.state.localParams.name}
						maxLength={20}
						onChange={this.onTextChange}
					/>
					<InputText
						name='responsibleUserName'
						label='Responsible User'
						type='text'
						value={this.state.localParams.responsibleUserName}
						maxLength={20}
						onChange={this.onTextChange}
					/>
					<InputText
						name='additionalInfo'
						label='Additional Info'
						type='text'
						value={this.state.localParams.additionalInfo}
						maxLength={20}
						onChange={this.onTextChange}
					/>
				</div>
			</Drawer>
		);
	}
}

ShowFiltersDrawer.propTypes = {
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	columnFilters: PropTypes.object.isRequired,
	searchParams: PropTypes.object.isRequired,
	isStartDateActive: PropTypes.bool.isRequired,
};
